export const fieldsToFill = [
  { fieldResponse: 'localidade', fieldForm: 'cidade' },
  { fieldResponse: 'bairro', fieldForm: 'bairro' },
  { fieldResponse: 'complemento', fieldForm: 'complemento' },
  { fieldResponse: 'logradouro', fieldForm: 'logradouro' },
  { fieldResponse: 'uf', fieldForm: 'uf' },
];

export default fieldsToFill;
